import { render, staticRenderFns } from "./HelpUserStat2.vue?vue&type=template&id=bf1c1994&scoped=true&"
import script from "./HelpUserStat2.vue?vue&type=script&lang=js&"
export * from "./HelpUserStat2.vue?vue&type=script&lang=js&"
import style0 from "./HelpUserStat2.vue?vue&type=style&index=0&id=bf1c1994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1c1994",
  null
  
)

export default component.exports